function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:black;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M7.18,17.921L5.079,5.978L15.821,4.08l2.1,11.942L7.18,17.921z M2.079,10.596l1.502-8.517l7.5,1.323 L10.99,3.918L4.413,5.081C4.141,5.128,3.96,5.388,4.007,5.659l0.958,5.445L2.079,10.596z M16.718,3.414 c-0.022-0.131-0.097-0.247-0.205-0.323c-0.11-0.076-0.243-0.107-0.374-0.083l-4.101,0.725l0.115-0.65 c0.047-0.272-0.134-0.531-0.406-0.579L3.262,1.008c-0.271-0.05-0.531,0.134-0.579,0.405l-1.675,9.501 c-0.023,0.131,0.006,0.266,0.083,0.374c0.076,0.109,0.192,0.183,0.322,0.206l3.737,0.658l1.132,6.435 c0.023,0.131,0.097,0.246,0.206,0.323C6.572,18.969,6.672,19,6.774,19c0.029,0,0.058-0.003,0.087-0.007l11.726-2.074 c0.272-0.048,0.453-0.306,0.405-0.579L16.718,3.414z M10.684,6.355C9.892,6.494,9.206,6.927,8.753,7.574 C8.322,8.189,8.155,8.931,8.284,9.66c0.048,0.272,0.306,0.452,0.579,0.405c0.272-0.048,0.454-0.308,0.406-0.579 C9.186,9.019,9.294,8.543,9.572,8.147c0.3-0.427,0.756-0.714,1.284-0.807c1.053-0.188,2.057,0.478,2.233,1.477 c0.108,0.614-0.17,0.99-0.673,1.603c-0.557,0.678-1.25,1.522-0.994,2.964c0.043,0.243,0.253,0.413,0.491,0.413 c0.029,0,0.059-0.002,0.088-0.008c0.272-0.048,0.453-0.308,0.405-0.579c-0.175-0.989,0.269-1.53,0.782-2.155 c0.506-0.617,1.081-1.316,0.885-2.412C13.801,7.103,12.286,6.076,10.684,6.355 M12.129,14.576c-0.32,0.056-0.533,0.362-0.477,0.683 c0.056,0.32,0.361,0.535,0.681,0.478s0.533-0.362,0.477-0.683C12.753,14.733,12.449,14.519,12.129,14.576"
});

function SvgQuiz(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "20px",
    height: "20px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuiz);
export default __webpack_public_path__ + "static/media/quiz.d3492ebe.svg";
export { ForwardRef as ReactComponent };